import * as React from "react"
import { Box } from "@mui/material";

import { HierarchicalTextBlock } from "@components";


export default function daysDeliveryColumn() {
	return [{
		name: 'avgDaysDelivery', label: 'Avg Days Delivery',
		options: {
			display: 'excluded',
			customBodyRowRender: value => value ? 'Has Avg Days Delivery' : 'No Avg Days Delivery'
		}
	}, {
		name: 'avgDaysDeliveryBB', label: 'Avg Days Delivery BB',
		options: {
			display: 'excluded',
			customBodyRowRender: value => value ? 'Has Avg Days Delivery BB' : 'No Avg Days DeliveryBB'
		}
	}, {
		name: '', label: 'Average Days Delivery',
		options: {
			filter: false,
			setCellProps: () => ({ sx: { textAlign: "center" } }),
			customBodyRowRenderLite: (value, row) => <Box sx={{ display: 'flex', flexDirection: 'column'}}>
				<HierarchicalTextBlock title="Avg Days Delivery: " titleValue={!!row.avgDaysDelivery ? row.avgDaysDelivery : '--' } />
				<HierarchicalTextBlock title="Avg Days Delivery BB: " titleValue={!!row.avgDaysDeliveryBB ? row.avgDaysDeliveryBB : '--'} />
			</Box>
		}
	}]
}
